import { atom } from 'recoil'
import type { Staff } from 'types/staff'

const me = atom<Staff | undefined>({
  key: 'me',
  default: undefined,
})

export default me
